import { AnyAction } from 'redux';
import { ActionDispatching, ComplexValue } from 'app/types-shared';
import { ApplicationState } from 'app/types-store';
import { complexValidationFromServer } from 'app/infrastructure/data/validation';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages/action-types';
import { mapActionsToWire } from './utils/map-actions';
import { mapListBranchItemFromWire } from './utils/map-list-branch-item';
import {
  RequestListBranch, ReceiveListBranch, FailListBranch,
  RequestSaveChanges, ReceiveSaveChanges, FailSaveChanges,
  ClearList
} from './action-types';
import { api } from './api';
import { endpoints } from './endpoints';
import { defaultMaxResults } from './constants';
import { ListAction, ListBranchModel } from './types-store';

export const actionCreators = {

  loadListBranch: (
    model: ListBranchModel, id: number = 0,
    startIndex: number = 0, maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      dispatch(new RequestListBranch(model, id));

      try {
        const listBranch = await api.loadListBranch(model, startIndex, maxResults);
        const listBranchItems = mapListBranchItemFromWire(listBranch.results);
        const numberOfResults = listBranch.totalNumberOfResults;
        const clearList = startIndex === 0;

        dispatch(new ReceiveListBranch(model, id, listBranchItems, numberOfResults, clearList));

      } catch (err) {

        const error = err && (err.userMessages || err.message);
        error && dispatch(new ErrorNotification(error));

        dispatch(new FailListBranch(model, id));
      }
    },

  saveChanges: (
    model: ListBranchModel,
    activeValue: ComplexValue<number>,
    listActions: ListAction[],
    successMessage: string,
    errorMessage: string
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      dispatch(new RequestSaveChanges(model, activeValue));

      try {

        await api.saveChanges(
          mapActionsToWire(listActions),
          endpoints.saveActions(model.subscriberGroup)
        );

        dispatch(new ReceiveSaveChanges(model, activeValue));
        dispatch(new SuccessNotification(successMessage));

      } catch (err) {
        const error = err && (err.userMessages || err.message);
        error && dispatch(new ErrorNotification(error));

        const actionsErrors = Object.keys(err?.validationErrors ?? {}).length > 0
          ? complexValidationFromServer(err.validationErrors)?.actions?.messages ?? []
          : [];

        const activeValueError = err?.validationErrors?.payload
          && complexValidationFromServer(err.validationErrors)?.payload?.messages?.[0];

        activeValueError && dispatch(new ErrorNotification(errorMessage));

        dispatch(new FailSaveChanges(model, activeValue, actionsErrors, activeValueError));
      }
    },

  clearList: (model: ListBranchModel): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {
      dispatch(new ClearList(model));
    }
};
